function ListLoader({ size = 40, dataTestId }) {
	const spinnerSize = size * 0.6;
	const baseTestId = dataTestId;

	return (
		<div
			data-testid={`${baseTestId}-container`}
			className="flex items-center justify-center"
			style={{ height: size }}
		>
			<div
				className="animate-spin rounded-full border-gray-400 border-t-2 border-b-2"
				style={{ width: spinnerSize, height: spinnerSize }}
			/>
		</div>
	);
}

export default ListLoader;
